export const SUBSCRIPTION_TIERS = {
  starter: {
    name: "Starter",
    price: 19,
    price_id: "price_1T1OkePGCmeIMVviTlteCwXv",
    product_id: "prod_TzNVc0gkuuzgsj",
    proposalLimit: 10,
    trialNote: "Includes 7-day free trial",
    features: [
      "7-day free trial included",
      "Up to 10 proposals/month",
      "FBI crime data integration",
      "PDF export",
      "Email support",
    ],
    excludes: ["Contract generator"],
  },
  professional: {
    name: "Professional",
    price: 49,
    price_id: "price_1T1OkgPGCmeIMVviNyXYXi1t",
    product_id: "prod_TzNV9pLdP3Wr7C",
    proposalLimit: null, // unlimited
    features: [
      "Unlimited proposals",
      "Contract generator",
      "Priority AI processing",
      "Photo evidence analysis",
      "Advanced cost calculator",
      "Priority support",
    ],
  },
  agency: {
    name: "Agency",
    price: 99,
    price_id: "price_1T1OkiPGCmeIMVvimlH3iRxi",
    product_id: "prod_TzNV6IEVtmi6LB",
    proposalLimit: null,
    features: [
      "Everything in Professional",
      "Company logo on proposals",
      "Team member accounts",
      "Client portal access",
      "Bulk proposal generation",
      "Dedicated account manager",
    ],
  },
  enterprise: {
    name: "Enterprise",
    price: null, // custom pricing
    price_id: null,
    product_id: null,
    proposalLimit: null,
    internal: true, // shown via special handling, not standard checkout
    description: "For organizations that need advanced customization, API access, and SLA‑backed support.",
    features: [
      "White‑labeling & full custom branding",
      "Custom proposal themes & colors",
      "Custom footer text",
      "API access",
      "Custom workflows",
      "Dedicated support channel",
      "SLA guarantees",
      "Expanded team seats",
      "Priority AI processing",
      "Dedicated account manager",
    ],
    pricingFactors: [
      "Team size",
      "API usage",
      "Workflow customization",
      "SLA level",
    ],
  },
  testing: {
    name: "Testing",
    price: null,
    price_id: null,
    product_id: null,
    proposalLimit: null, // unlimited
    internal: true, // hidden from public pricing, excluded from stats
    features: [
      "Internal testing account",
      "Unlimited proposals",
      "Excluded from billing metrics",
    ],
  },
} as const;

export type SubscriptionTierKey = keyof typeof SUBSCRIPTION_TIERS;

/** Demo tiers mirror real tiers but never touch billing */
export const DEMO_TIER_TO_REAL: Record<string, SubscriptionTierKey> = {
  starter_demo: "starter",
  professional_demo: "professional",
  agency_demo: "agency",
};

export function isDemoTier(tier: string | null): boolean {
  return !!tier && tier in DEMO_TIER_TO_REAL;
}

export function resolveEffectiveTier(tier: string | null): SubscriptionTierKey | null {
  if (!tier) return null;
  if (tier in DEMO_TIER_TO_REAL) return DEMO_TIER_TO_REAL[tier];
  return tier as SubscriptionTierKey;
}

export function getTierByProductId(productId: string | null): SubscriptionTierKey | null {
  if (!productId) return null;
  for (const [key, tier] of Object.entries(SUBSCRIPTION_TIERS)) {
    if (tier.product_id === productId) return key as SubscriptionTierKey;
  }
  return null;
}

export function getTierByPriceId(priceId: string | null): SubscriptionTierKey | null {
  if (!priceId) return null;
  for (const [key, tier] of Object.entries(SUBSCRIPTION_TIERS)) {
    if (tier.price_id === priceId) return key as SubscriptionTierKey;
  }
  return null;
}
